// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__MNERh","validationTips":"StatementDescriptor_validationTips__2mfiN"};